{
  "screen": {
    "sectionHeading": "Ward and bed",
    "open": "Move patient",
    "heading": "Move patient",
    "explanation": "Moves the patient to another ward or bed. It is the same episode of care, so the admission time does not change.",
    "from": "The patient is now on {location}, since {since}.",
    "requiredHint": "Fields with no note must be filled in.",
    "optional": "optional",
    "final": "A move cannot be removed. The current placement stays in the record. If it was wrong, move the patient again.",
    "save": "Move the patient",
    "saving": "Moving …",
    "cancel": "Cancel",
    "close": "Close",
    "saved": "The patient has been moved to {ward}.",
    "discardQuestion": "Close the form? The patient will not be moved.",
    "discardConfirm": "Close without moving",
    "discardCancel": "Keep filling it in"
  },
  "field": {
    "ward": "To ward",
    "bed": "Bed",
    "movedAt": "Moved"
  },
  "fieldHint": {
    "ward": "The ward the patient is moving to. The same ward also works, to change bed.",
    "bed": "Room and bed as staff say them. Leave empty if there is no bed — the patient is then listed last on the ward, without a bed.",
    "movedAt": "When the move happened, as YYYY-MM-DD HH:mm on a 24-hour clock. Change it if the move happened earlier than now, but not before {since}."
  },
  "refusal": {
    "wardMissing": "Choose the ward the patient is moving to. The patient was not moved.",
    "wardNotFound": "Ward {ward} is not in the record. The patient was not moved.",
    "fieldTooLong": "The bed is too long. Shorten it to at most {max} characters. The patient was not moved.",
    "movedAtMissing": "Fill in when the move happened. The patient was not moved.",
    "movedAtMalformed": "The time of the move does not read as a time. Write it as YYYY-MM-DD HH:mm, for example 2026-10-15 08:00. The patient was not moved.",
    "movedAtInFuture": "The time of the move is in the future. The patient was not moved.",
    "beforeCurrent": "The move cannot have happened before {since}, when the patient arrived where they are now. The patient was not moved.",
    "noChange": "The patient is already there. Choose another ward or bed. The patient was not moved.",
    "stale": "Somebody else moved the patient while the form was open. The overview has been updated — check where the patient is now and try again. The patient was not moved.",
    "notActive": "The patient is no longer admitted and cannot be moved. The patient was not moved.",
    "notFound": "The episode of care is not in the record. Open the patient overview again. The patient was not moved.",
    "roleMayNotDocument": "Your role may not document in the record. The patient was not moved.",
    "unknown": "The patient was not moved. Try again.",
    "unavailable": "No contact with the server. It is not certain whether the patient was moved — open the patient overview again and check where they are before trying again."
  }
}
